import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "purchasesList", // Target for the list of purchases
    "searchInput", // Target for the search input
    "summary", // Target for the summary information
    "purchase", // Target for each purchase item
  ];

  static values = {
    eventId: String, // Value for the current event ID
  };

  connect() {
    // Initialize the search functionality
    this.initializeSearch();

    // Make the enter key submit the search
    this.searchInputTarget.addEventListener("keypress", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        this.search();
      }
    });

    // Listen for Turbo Stream events to reapply search filtering
    document.addEventListener("turbo:before-stream-render", () => {
      this.reapplySearchAfterStream();
    });
  }

  initializeSearch() {
    // Debounce search input to avoid too many redraws
    let debounceTimer;
    this.searchInputTarget.addEventListener("input", (e) => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => this.search(), 300);
    });
  }

  search() {
    const searchTerm = this.searchInputTarget.value.toLowerCase().trim();

    // Show all purchases if search term is empty
    if (!searchTerm) {
      this.purchaseTargets.forEach((purchase) => {
        purchase.classList.remove("hidden");
      });
      return;
    }

    // Filter purchases based on search term
    this.purchaseTargets.forEach((purchase) => {
      const purchaseText = purchase.textContent.toLowerCase();
      if (purchaseText.includes(searchTerm)) {
        purchase.classList.remove("hidden");
      } else {
        purchase.classList.add("hidden");
      }
    });
  }

  clearSearch() {
    this.searchInputTarget.value = "";
    this.search();
    this.searchInputTarget.focus();
  }

  reapplySearchAfterStream() {
    // Reapply search filter if active after DOM updates
    setTimeout(() => {
      if (this.searchInputTarget.value) {
        this.search();
      }
    }, 0);
  }
}
